import { post } from 'app/utils/axios/kheti'
import { DemoMaterialRequest } from 'app/models/RequestFlow'

export type CreateDemoMaterialRequestPayload = {
  vendor_id: number
  product_variant_id: number
  farmer_name: string
  farmer_mobile: string
  units: number
  address: string
  pin_code: string
  state_id: number
  district_id: number
  block_id: number
  village_id: number
  crop_id?: number
  inventory_node_id?: number
  remarks?: string
}

const createDemoMaterialRequest = async (
  payload: CreateDemoMaterialRequestPayload,
) => {
  return post<DemoMaterialRequest>(
    '/approvals/v1/demo-material-issuance/requests',
    payload,
  )
}

export default createDemoMaterialRequest
